<script setup lang="ts">
import type { RouteLocationRaw } from '#vue-router'

const t2 = useT2({})

export type Props = {
  option?: gen.ProductAttrs[] | None
  isNew?: boolean
  to?: RouteLocationRaw
  outOfStockMsg?: string | None
  discountMsg?: string | None
  title: string | None
  description?: string | None
  departmentName: string | None
  maxOptions?: number | None
}

const props = defineProps<Props>()

const ui = computed(() => {
  const { title, departmentName } = props
  const { option, maxOptions } = props
  const items = helpers.arr(option)

  return {
    optionsItems: typeof maxOptions === 'number' ? items.slice(0, maxOptions) : items,
    title: helpers.toString(title),
    departmentName: helpers.toString(departmentName),
  }
})
</script>

<template>
  <div class="_c1">
    <div v-if="ui.departmentName || isNew" class="_row _ctrY _gap1 _hm20 _mb02">
      <div v-if="ui.departmentName" class="_ff3 _fw-xl _fs08" :class="$style.category">{{ ui.departmentName }}</div>
      <UiMsg v-if="isNew" class="_fs08" :txt="t2('New product')" />
    </div>

    <slot name="title" :classTitle="$style.title">
      <template v-if="ui.title">
        <NuxtLink v-if="to" :to
          ><div :class="$style.title">{{ ui.title }}</div></NuxtLink
        >
        <div v-else :class="$style.title">{{ ui.title }}</div>
      </template>
    </slot>
    <span v-if="description?.length" class="_txt _pt1 _fs09">{{ description }}</span>

    <slot />

    <table v-if="ui.optionsItems?.length" :class="$style.t" class="_mt08">
      <tr v-for="item in ui.optionsItems" :key="item.key" class="_fs09">
        <td>{{ helpers.toString(item.uiKey) }}</td>
        <td>{{ helpers.toString(item.uiValue) }}</td>
      </tr>
    </table>

    <slot name="bottom" />

    <div v-if="discountMsg || outOfStockMsg || $slots.messages || $slots.messagesTop" class="_row _gap04 _wrap _pt04 _pb04">
      <UiMsg v-if="discountMsg" :txt="discountMsg" />
      <UiMsg v-if="outOfStockMsg" red :txt="outOfStockMsg" />
      <slot name="messagesTop" />
      <slot name="messages" />
    </div>

    <slot name="bottom2" />
  </div>
</template>

<style module>
.title {
  composes: global(_fw-l);
  composes: global(_relative);
  composes: global(d_fs1);
  composes: global(m_fs09);
  composes: global(_pt02);
  composes: global(_pb02);
  composes: global(_ws_normal);

  /* TODO conflicting deps */
  composes: global(_w100p);
  composes: global(_ellipsis);
  /* composes: global(_h44); */

  max-height: 44px;
  line-height: 14px;
}
.category {
  composes: global(_wcont);
  composes: global(_noflex);
  composes: global(_ws_nowrap);

  word-break: keep-all;
}

.t td {
  line-height: 14px;
  text-align: left;
}
.t td:first-of-type {
  min-width: 60px;
  padding: 0 4px 0 0;
}
</style>
